import axios from 'axios'
import CustomError from './custom-error'
import https from 'https'

const httpsAgent = new https.Agent({
  rejectUnauthorized: false, // (NOTE: this will disable client verification)
})

const axiosClient = axios.create({ httpsAgent });

axiosClient.interceptors.response.use(
  res => res,

  err => {
    
    const signerMessage = err.config.url.includes("localhost:8897") 
      ? `Usluga potpisivanja odabranog izdavatelja certifikata nije dostupna (FINA Upravljački progami) na vašem računalu.\n
         Molimo kontaktirajte podršku izdavatelja Vašeg certifikata na: info@fina.hr ili 0800 0080`
      : `Usluga potpisivanja odabranog izdavatelja certifikata nije dostupna (Certilia Signer) na vašem računalu. Molimo kontaktirajte podršku izdavatelja Vašeg certifikata`
    
      if(err.response) {      
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // ovo je za finu...
      if(parseInt(err.response.status) === 417) {
        // ovaj code vraca fina middleware ako se klikne na odustani
        throw new CustomError('Izrada elektroničkog potpisa je prekinuta na zahtjev korisnika', {code: parseInt(5)})  
      }
      const { id, message, code } = err?.response?.data?.error
      throw new CustomError(message, {id, message, code: parseInt(code)})
   
   
    } else if (err.request) {
       // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      // if(err.config.url.includes('esign-local.id.hr:55555')) {

      //   throw new CustomError('eSigner does not running', { message: 'eSigner does not running', code: 0})
      // }
      if(err.message === 'Network Error') {
        
        throw new CustomError('eSigner does not running', { message: signerMessage, code: 26})
      }
      throw new Error(err.message)
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new Error(err.message)
    }
    
  }
)

export default axiosClient